import logo from './logo.png';
import regionalx from './FondoMiseguro.jpg';
import regionalxEnglish from './ImagenesIngles/PÁGINA SLIDE - SOMIT INGLÉS .jpg';
import './App.css';
import Forms from './Forms.js';
import Footer from './Footer.js';
import SelectorPais, { ID_SELECTOR_PAIS_NAVBAR } from './SelectorPais.js';
import SelectorIdioma from './SelectorIdioma.js';
import React, { useState, useEffect, Component } from 'react';
import {
  Navbar, NavbarBrand,
  NavbarToggler, Nav, NavItem,
  Collapse,
  NavbarText,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaUserAlt } from 'react-icons/fa';
import { FaSignInAlt } from 'react-icons/fa';
import { FaCalculator } from 'react-icons/fa';
import { FaArrowUp } from 'react-icons/fa';
import $ from 'jquery';
import { IdiomaContext } from './context/IdiomaContext';
//import axios from 'axios';
import swal from 'sweetalert';
import axios from './axios-config';
require('dotenv').config()



class App extends Component {
  static contextType = IdiomaContext;
  handleDatosVersion = (datos) => {
    this.setState({ versioApp: datos });
  };

  constructor(props) {
    sessionStorage.clear();
    sessionStorage.removeItem("ejecutivoEncargado");
    super(props);
    this.state = {
      state: "",
      msie: window.navigator.userAgent.indexOf('MSIE ') > -1,
      trident: window.navigator.userAgent.indexOf('Trident/') > -1,
      edge: window.navigator.userAgent.indexOf('Edge/') > -1,
      rev: false,
      isOpen: false
    }

    this.toggle = this.toggle.bind(this);
    this.reload = this.reload.bind(this);
    //   this.newContact = this.newContact.bind(this);

    //obtenemos la version del sitio
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/getParametrosGeneralesAPP/VERSION-APP?pais=`+sessionStorage.getItem('paisCliente'),
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((json) => {
        if (json.status == 200) {
          let version = json.data.ParametrosAppSomit.find(
            (item) => item.nombreParametro.toLowerCase() === "version-mi-seguro"
          ).valorParametro;
          this.setState({ versioApp: "v" + version });
        }
      });

  }

  reload() {
    sessionStorage.clear();
    swal({
      title: 'Somit',
      text: 'Espera un momento, se esta cerrando tu sesión, esperamos que vuelvas pronto',
      icon: 'success',
      timer: 4000,
      buttons: false,
    })
      .then(() => {
        window.location.reload(true);
      })

  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {

    setTimeout(function () {
      axios.get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/validacion/1`, {
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
        },
      }).then(azasgua => {
        if (azasgua.status === 200) {
          //console.log("encontre bd 200")
          $("#hidedpi").val(azasgua.data.azasguaDpi);
          $("#hidefecnac").val(azasgua.data.azasguaFechaNac);
          $("#hdPagadoresAzasgua").val(azasgua.data.azasguaPagadores);
          $('#hdNumPolAzasgua').val(azasgua.data.azasguaPoliza);
          $('#hdClienteAzasgua').val(azasgua.data.azasguaClientePoliza);
        } else {
          //console.log("Error",azasgua.status);
          $("#hidedpi").val("2325977");
          $("#hidefecnac").val("1999-05-01T00:00:00-06:00");
          $("#hdPagadoresAzasgua").val("1800|1801|1803|1804|1806|498956");
          $("#hdEsAzasgua").val("N");
          $('#hdNumPolAzasgua').val("537");
          $('#hdClienteAzasgua').val("72");
        }
      }).catch(function (error) {
        //console.log("Excepcion",error);
        $("#hidedpi").val("2325977");
        $("#hidefecnac").val("1999-05-01T00:00:00-06:00");
        $("#hdPagadoresAzasgua").val("1800|1801|1803|1804|1806|498956");
        $("#hdEsAzasgua").val("N");
        $('#hdNumPolAzasgua').val("537");
        $('#hdClienteAzasgua').val("72");
      });
    }, 1000)

    if (this.state.msie == true || this.state.trident == true || this.state.edge == true) {
      //console.log('explorer')
      swal("Error", "Estas utilizando Internet Explorer, por favor intentar con otro navegador", "error");
      this.setState({ rev: false });
    }

    return (
      <div className="mi-seguro-app">

        <div id="principal" name="principal" className="app-shell" style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",      
          backgroundImage: `linear-gradient(90deg, rgba(0, 52, 121, 0.34), rgba(135, 36, 52, 0.12)), url(${this.context?.language === "en" ? regionalxEnglish : regionalx})`
        }}>
          <Navbar light expand="md" className="app-navbar">
            <NavbarBrand href="/" className="app-navbar__brand">

            </NavbarBrand>

            <SelectorPais id={ID_SELECTOR_PAIS_NAVBAR} className="app-navbar__pais" />
            <SelectorIdioma />

            <NavbarToggler onClick={this.toggle} className="app-navbar__toggle" />

            <Collapse isOpen={this.state.isOpen} navbar id="logout" name="logout" className="app-navbar__collapse" >

              <Nav className="app-navbar__nav" navbar>
                <NavItem id="nvClienteExterno" name="nvClienteExterno" style={{ display: 'none' }}>
                  <NavLink className="app-navbar__client"><strong><label id="nomClienteExterno" name="nomClienteExterno"></label></strong></NavLink>
                </NavItem>
                <NavItem id="loga" name="loga" style={{ display: 'none' }}>
                  <NavLink className="app-navbar__logout"><a onClick={() => this.reload()} ><strong><FaUserAlt />&nbsp;&nbsp;Desconectar</strong></a></NavLink>
                </NavItem>

              </Nav>

            </Collapse>

          </Navbar>

          <div>
            <input type="hidden" id="hidedpi" name="hidedpi" val=""></input>
            <input type="hidden" id="hidefecnac" name="hidefecnac" val=""></input>
            <input type="hidden" id="hdClienteAzasgua" name="hdClienteAzasgua" val="0"></input>
            <input type="hidden" id="hdEsAzasgua" name="hdEsAzasgua" val="N"></input>
            <input type="hidden" id="hdPagadoresAzasgua" name="hdPagadoresAzasgua" val="0"></input>
            <input type="hidden" id="hdNumPolAzasgua" name="hdNumPolAzasgua" val="0"></input>
            <input type="hidden" id="hdClienteActual" name="hdClienteActual" val="0"></input>
          </div>
          <main className="app-content">
            {(!this.state.msie || !this.state.trident || !this.state.edge) && <Forms />}
          </main>
          <button
            type="button"
            className="scroll-top-button"
            aria-label="Subir al inicio"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <FaArrowUp />
          </button>

        </div>

        <Footer versionApp={this.state.versioApp} />
      </div>);
  }
}
export default App;
